"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JeedContext = exports.useJeed = exports.JeedProvider = void 0;
const jeed_types_1 = require("@cs124/jeed-types");
const react_1 = __importStar(require("react"));
const JeedProvider = ({ googleToken, server, children }) => {
    const [status, setStatus] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        fetch(server)
            .then((response) => response.json())
            .then((response) => setStatus(response.status))
            .catch(() => setStatus(undefined));
    }, [server]);
    const run = (0, react_1.useCallback)((request_1, ...args_1) => __awaiter(void 0, [request_1, ...args_1], void 0, function* (request, validate = false) {
        request = validate ? jeed_types_1.Request.check(request) : request;
        const response = yield fetch(server, {
            method: "post",
            body: JSON.stringify(request),
            headers: Object.assign({ "Content-Type": "application/json" }, googleToken ? { "google-token": googleToken } : null),
            credentials: "include",
        })
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            if (response.status === 200) {
                const r = yield response.json();
                setStatus(r.status);
                return r;
            }
            else {
                throw yield response.text();
            }
        }))
            .catch((err) => {
            setStatus(undefined);
            throw err;
        });
        return validate ? jeed_types_1.Response.check(response) : response;
    }), [googleToken, server]);
    return (react_1.default.createElement(exports.JeedContext.Provider, { value: { available: true, status, connected: status !== undefined, run } }, children));
};
exports.JeedProvider = JeedProvider;
const useJeed = () => {
    return (0, react_1.useContext)(exports.JeedContext);
};
exports.useJeed = useJeed;
exports.JeedContext = react_1.default.createContext({
    available: false,
    connected: false,
    status: undefined,
    run: () => {
        throw new Error("Jeed Context not available");
    },
});
//# sourceMappingURL=index.js.map